import { render, staticRenderFns } from "./distributeRecord.vue?vue&type=template&id=35a433f2&"
import script from "./distributeRecord.vue?vue&type=script&lang=js&"
export * from "./distributeRecord.vue?vue&type=script&lang=js&"
import style0 from "./distributeRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports